type SiteType = "IN" | "ME" | "ANZ" | "GLOBAL" | "LOCAL" | "UNKNOWN";

type ApiMapEntry = {
  pattern: RegExp;
  apiUrl: string;
  frontEndUrl: string;
  siteType: SiteType;
  gtmId: string;
  gaId: string;
  googleSiteVerificationCode?: string;
  // Web push is scoped to an origin, so every domain needs its own OneSignal
  // app. Left unset, the host falls back to NEXT_PUBLIC_ONESIGNAL_APP_ID.
  oneSignalAppId?: string;
};

export const domainToApiMap: Record<string, string> = {
  // UAT
  "uat-me-pm.enpointe.io": "https://api-me-pm.enpointe.io",
  "uat-global-pm.enpointe.io": "https://api-global-pm.enpointe.io",
  "uat-anz-pm.enpointe.io": "https://api-anz-pm.enpointe.io",
  "uat-india-pm.enpointe.io": "https://api-india-pm.enpointe.io",

  // Beta
  "beta.peoplematters.in": "https://beta-api.peoplematters.in",
  "beta-me.peoplemattersglobal.com":
    "https://beta.api-me.peoplemattersglobal.com",
  "beta-anz.peoplemattersglobal.com":
    "https://beta.api-anz.peoplemattersglobal.com",
  "beta.peoplemattersglobal.com":
    "https://beta.api-global.peoplemattersglobal.com",
  // Production
  "www.peoplematters.in": "https://api.peoplematters.in",
  "anz.peoplemattersglobal.com": "https://api-anz.peoplemattersglobal.com",
  "sea.peoplemattersglobal.com": "https://api-sea.peoplemattersglobal.com",
  "me.peoplemattersglobal.com": "https://api-me.peoplemattersglobal.com",

  "qa-me.peoplemattersglobal.com": "https://qa.api-me.peoplemattersglobal.com",
  "qa-anz.peoplemattersglobal.com": "https://qa.api-anz.peoplemattersglobal.com",
  "qa.peoplematters.in": "https://qa-api.peoplematters.in",
  "test.peoplematters.in": "https://qa-api.peoplematters.in",
  "testpg.thinkry.tech": "https://qa-api.peoplematters.in",
  "peoplematter.thinkry.tech": "https://qa-api.peoplematters.in",
  "qa-sea.peoplemattersglobal.com": "https://qa.api-sea.peoplemattersglobal.com",

  // "beta-peoplematter.enpointe.io":"",
  localhost: "http://localhost:3001",
};

function getPatternApiUrl(hostname: string): string | undefined {
  // if (hostname.startsWith("uat-me-pm.")) return "https://api-me-pm.enpointe.io";
  // if (hostname.startsWith("uat-global-pm.")) return "https://api-global-pm.enpointe.io";
  // if (hostname.startsWith("uat-anz-pm.")) return "https://api-anz-pm.enpointe.io";
  // if (hostname.startsWith("uat-india-pm.")) return "https://api-india-pm.enpointe.io";
  // if (hostname.startsWith("beta.peoplematters.")) return "https://beta-api.peoplematters.in";
  // if (hostname.startsWith("beta-me.")) return "https://beta.api-me.peoplemattersglobal.com";
  // if (hostname.startsWith("beta-anz.")) return "https://beta.api-anz.peoplemattersglobal.com";
  // if (hostname.startsWith("beta.peoplemattersglobal.")) return "https://beta.api-global.peoplemattersglobal.com";

  // UAT
  if (hostname.startsWith("uat-me-pm.")) return "https://api-me-pm.enpointe.io";
  if (hostname.startsWith("uat-global-pm."))
    return "https://api-global-pm.enpointe.io";
  if (hostname.startsWith("uat-anz-pm."))
    return "https://api-anz-pm.enpointe.io";
  if (hostname.startsWith("uat-india-pm."))
    return "https://api-india-pm.enpointe.io";

  // Beta
  if (hostname.startsWith("beta.peoplematters.in"))
    return "https://beta-api.peoplematters.in";
  if (hostname.startsWith("beta-me.peoplemattersglobal.com"))
    return "https://beta.api-me.peoplemattersglobal.com";
  if (hostname.startsWith("beta-anz.peoplemattersglobal.com"))
    return "https://beta.api-anz.peoplemattersglobal.com";
  if (hostname.startsWith("beta.peoplemattersglobal."))
    return "https://beta.api-global.peoplemattersglobal.com";

  // Production (handle startsWith)
  if (hostname.startsWith("www.peoplematters.in"))
    return "https://api.peoplematters.in";
  if (hostname.startsWith("anz.peoplemattersglobal.com"))
    return "https://api-anz.peoplemattersglobal.com";
  if (hostname.startsWith("sea.peoplemattersglobal.com"))
    return "https://api-sea.peoplemattersglobal.com";
  if (hostname.startsWith("me.peoplemattersglobal.com"))
    return "https://api-me.peoplemattersglobal.com";

  // QA

  if (hostname.startsWith("qa-anz.peoplemattersglobal.com"))
    return "https://qa.api-anz.peoplemattersglobal.com";
  if (hostname.startsWith("qa-me.peoplemattersglobal.com"))
    return "https://qa.api-me.peoplemattersglobal.com";
  if (hostname.startsWith("test.peoplematters.in"))
    return "https://qa-api.peoplematters.in";

  if (hostname.startsWith("testpg.thinkry.tech"))
    return "https://qa-api.peoplematters.in";

  if (hostname.startsWith("peoplematter.thinkry.tech"))
    return "https://qa-api.peoplematters.in";

  if (hostname.startsWith("qa.peoplematters.in"))
    return "https://qa-api.peoplematters.in";
  if (hostname.startsWith("qa-sea.peoplemattersglobal.com"))
    return "https://qa.api-sea.peoplemattersglobal.com";


  return undefined;
}

const hostApiPatterns: ApiMapEntry[] = [
  // UAT
  {
    pattern: /^uat-me-pm\./,
    apiUrl: "https://api-me-pm.enpointe.io",
    frontEndUrl: "https://uat-me-pm.enpointe.io",
    siteType: "ME",
    gtmId: "",
    gaId: "",
    googleSiteVerificationCode: "",
  },
  {
    pattern: /^uat-global-pm\./,
    apiUrl: "https://api-global-pm.enpointe.io",
    frontEndUrl: "https://uat-global-pm.enpointe.io",
    siteType: "GLOBAL",
    gtmId: "",
    gaId: "",
    googleSiteVerificationCode: "",
  },
  {
    pattern: /^uat-anz-pm\./,
    apiUrl: "https://api-anz-pm.enpointe.io",
    frontEndUrl: "https://uat-anz-pm.enpointe.io",
    siteType: "ANZ",
    gtmId: "",
    gaId: "",
    googleSiteVerificationCode: "",
  },
  {
    pattern: /^uat-india-pm\./,
    apiUrl: "https://api-india-pm.enpointe.io",
    frontEndUrl: "https://uat-india-pm.enpointe.io",
    siteType: "IN",
    gtmId: "",
    gaId: "",
    googleSiteVerificationCode: "",
  },

  // Beta
  {
    pattern: /^beta\.peoplematters\.in$/,
    apiUrl: "https://beta-api.peoplematters.in",
    frontEndUrl: "https://beta.peoplematters.in",
    siteType: "IN",
    gtmId: "",
    gaId: "",
    googleSiteVerificationCode: "",
  },
  {
    pattern: /^beta-me\./,
    apiUrl: "https://beta.api-me.peoplemattersglobal.com",
    frontEndUrl: "https://beta-me.peoplemattersglobal.com",
    siteType: "ME",
    gtmId: "",
    gaId: "",
    googleSiteVerificationCode: "",
  },
  {
    pattern: /^beta-anz\./,
    apiUrl: "https://beta.api-anz.peoplemattersglobal.com",
    frontEndUrl: "https://beta-anz.peoplemattersglobal.com",
    siteType: "ANZ",
    gtmId: "",
    gaId: "",
    googleSiteVerificationCode: "",
  },
  {
    pattern: /^beta\.peoplemattersglobal\./,
    apiUrl: "https://beta.api-global.peoplemattersglobal.com",
    frontEndUrl: "https://beta.peoplemattersglobal.com",
    siteType: "GLOBAL",
    gtmId: "",
    gaId: "",
    googleSiteVerificationCode: "",
  },

  // QA
  {
    pattern: /^qa-anz\.peoplemattersglobal\.com$/,
    apiUrl: "https://qa.api-anz.peoplemattersglobal.com",
    frontEndUrl: "https://qa-anz.peoplemattersglobal.com",
    siteType: "ANZ",
    gtmId: "",
    gaId: "",
    googleSiteVerificationCode: "",
  },
  {
    pattern: /^qa-me\.peoplemattersglobal\.com$/,
    apiUrl: "https://qa.api-me.peoplemattersglobal.com",
    frontEndUrl: "https://qa-me.peoplemattersglobal.com",
    siteType: "ME",
    gtmId: "",
    gaId: "",
    googleSiteVerificationCode: "",
  },
  {
    pattern: /^qa\.peoplematters\.in$/,
    apiUrl: "https://qa-api.peoplematters.in",
    frontEndUrl: "https://qa.peoplematters.in",
    siteType: "IN",
    gtmId: "",
    gaId: "",
    googleSiteVerificationCode: "",
  },
  {
    pattern: /^test\.peoplematters\.in$/,
    // pattern: /^qa\.peoplematters\.in$/,
    apiUrl: "https://qa-api.peoplematters.in",
    frontEndUrl: "https://test.peoplematters.in",
    // frontEndUrl: "https://qa.peoplematters.in",
    siteType: "IN",
    gtmId: "",
    gaId: "",
    googleSiteVerificationCode: "",
  },
  {
    pattern: /^testpg\.thinkry\.tech$/,
    // pattern: /^qa\.peoplematters\.in$/,

    apiUrl: "https://qa-api.peoplematters.in",
    frontEndUrl: "https://testpg.thinkry.tech",
    // frontEndUrl: "https://qa.peoplematters.in",
    siteType: "IN",
    gtmId: "",
    gaId: "",
    googleSiteVerificationCode: "",
  },
  {
    pattern: /^peoplematter\.thinkry\.tech$/,
    apiUrl: "https://qa-api.peoplematters.in",
    frontEndUrl: "https://peoplematter.thinkry.tech",
    siteType: "IN",
    gtmId: "",
    gaId: "",
    googleSiteVerificationCode: "",
  },
  {
    pattern: /^qa-sea\.peoplemattersglobal\.com$/,
    apiUrl: "https://qa.api-sea.peoplemattersglobal.com",
    frontEndUrl: "https://qa-sea.peoplemattersglobal.com",
    siteType: "GLOBAL",
    gtmId: "",
    gaId: "",
    googleSiteVerificationCode: "",
  },
  // Production
  {
    pattern: /^www\.peoplematters\.in$/,
    apiUrl: "https://api.peoplematters.in",
    frontEndUrl: "https://www.peoplematters.in",
    siteType: "IN",
    gtmId: "GTM-MVHFS43X",
    gaId: "G-QMBXZPJ04X",
    googleSiteVerificationCode: "0cW3FyAPQjbKytNlIXmi-_YMXAH8o6uiLkWmjz5B0Ww",
    oneSignalAppId: "",
  },
  {
    pattern: /^anz\.peoplemattersglobal\.com$/,
    apiUrl: "https://api-anz.peoplemattersglobal.com",
    frontEndUrl: "https://anz.peoplemattersglobal.com",
    siteType: "ANZ",
    gtmId: "",
    gaId: "G-E30WFP6BGK",
    googleSiteVerificationCode: "",
    oneSignalAppId: "",
  },
  {
    pattern: /^sea\.peoplemattersglobal\.com$/,
    apiUrl: "https://api-sea.peoplemattersglobal.com",
    frontEndUrl: "https://sea.peoplemattersglobal.com",
    siteType: "GLOBAL",
    gtmId: "",
    gaId: "G-S24EHT4K9R",
    googleSiteVerificationCode: "gsNHZFDQTPda5g-rLr5BrjuBOEw7HY2Zk70muwv9-j0",
    oneSignalAppId: "",
  },
  {
    pattern: /^me\.peoplemattersglobal\.com$/,
    apiUrl: "https://api-me.peoplemattersglobal.com",
    frontEndUrl: "https://me.peoplemattersglobal.com",
    siteType: "ME",
    gtmId: "",
    gaId: "G-CRGF02ME3W",
    googleSiteVerificationCode: "",
    oneSignalAppId: "",
  },

  // Local
  {
    pattern: /^localhost:8082$/,
    apiUrl: "http://localhost:3001",
    frontEndUrl: "http://localhost:8082",
    siteType: "LOCAL",
    gtmId: "",
    gaId: "",
    googleSiteVerificationCode: "",
  },
];

export function getStaticHost(host?: string): string {
  if (!host) return "";
  let host1 = host;
  switch (host1) {
    case "qa.peoplematters.in":
      host1 = "test.peoplematters.in";
      break;
    case "origin.peoplematters.in":
      host1 = "www.peoplematters.in";
      break;
    case "anz-origin.peoplemattersglobal.com":
      host1 = "anz.peoplemattersglobal.com";
      break;
    case "me-origin.peoplemattersglobal.com":
      host1 = "me.peoplemattersglobal.com";
      break;
    case "sea-origin.peoplemattersglobal.com":
      host1 = "sea.peoplemattersglobal.com";
      break;

    case "beta.origin.peoplematters.in":
      host1 = "beta.peoplematters.in";
      break;
    case "beta-anz-origin.peoplemattersglobal.com":
      host1 = "beta-anz.peoplemattersglobal.com";
      break;
    case "beta-me-origin.peoplemattersglobal.com":
      host1 = "beta-me.peoplemattersglobal.com";
      break;
    case "beta-sea-origin.peoplemattersglobal.com":
      host1 = "beta.peoplemattersglobal.com";
      break;
    default:
      break;
  }
  return host1;
}

export function getApiBaseUrl(host?: string, isExternal: boolean = false): string {
  let hostname = host;
  // console.log('isExternal=>',isExternal)
  // console.log("getApiBaseUrl hostname 1", hostname);
  if (!hostname && typeof window !== "undefined") {
    hostname = window.location.hostname;
    // console.log("getApiBaseUrl hostname 2", hostname);
  }

  if (isExternal) {
    const baseLocalURL = process.env.NEXT_PUBLIC_API_LOCAL as string;
    // console.log('baseLocalURL=>',baseLocalURL);
    return baseLocalURL;
  }


  if (hostname) {
    hostname = hostname.toLowerCase();
    // console.log("getApiBaseUrl hostname 3", hostname);
    if (domainToApiMap[hostname]) {
      // console.log("getApiBaseUrl hostname 4", hostname);
      return domainToApiMap[hostname];
    }

    const patternUrl = getPatternApiUrl(hostname);
    // const { apiUrl } = matchSiteConfig(hostname);
    // console.log("getApiBaseUrl hostname 5", hostname);
    if (patternUrl) {
      return patternUrl;
    }
  }

  if (!process.env.NEXT_PUBLIC_API_BASE_URL) {
    if (typeof window === "undefined") {
      console.warn(
        "Warning: NEXT_PUBLIC_API_BASE_URL is not set in environment variables."
      );
    }
  }
  return process.env.NEXT_PUBLIC_API_BASE_URL || "";
}

export function getFrontEndUrl(host?: string): string {
  // console.log("getFrontEndUrl hostname 1", host, referer);
  if (host) {
    // console.log("getFrontEndUrl hostname 2", host);
    return host;
  }
  if (typeof window !== "undefined") {
    // console.log("getFrontEndUrl hostname 3", window.location.hostname);
    return window.location.hostname;
  }
  // console.log("getFrontEndUrl hostname 4", process.env.NEXT_PUBLIC_SITE_URL);
  return process.env.NEXT_PUBLIC_SITE_URL || "";
}


export function buildHeaders(
  token?: string,
  referer?: string,
  host?: string
): Record<string, string> {
  const base: Record<string, string> = {};

  if (token) {
    base["Authorization"] = `Bearer ${token}`;
  }

  const origin = getFrontEndUrl(host);
  // console.log("origin ", origin, referer);
  if (typeof window === "undefined") {
    return {
      ...base,
      Origin: origin,
      Referer: origin,
    };
  } else {
    base["Origin"] = origin;
    base["Referer"] = origin;
  }

  return base;
}

export function matchSiteConfig(hostname: string): {
  apiUrl: string;
  siteType: SiteType;
  frontEndUrl: string;
  gtmId?: string;
  gaId?: string;
  googleSiteVerificationCode?: string;
  oneSignalAppId?: string;
} {
  const cleanHost = hostname.toLowerCase();
  const fallbackOneSignalAppId = process.env.NEXT_PUBLIC_ONESIGNAL_APP_ID || "";

  for (const { pattern, apiUrl, frontEndUrl, siteType, gtmId, gaId, googleSiteVerificationCode, oneSignalAppId } of hostApiPatterns) {
    if (pattern.test(cleanHost)) {
      return {
        apiUrl,
        siteType,
        frontEndUrl,
        gtmId,
        gaId,
        googleSiteVerificationCode,
        oneSignalAppId: oneSignalAppId || fallbackOneSignalAppId,
      };
    }
  }

  return {
    apiUrl: process.env.NEXT_PUBLIC_API_BASE_URL || "",
    frontEndUrl: process.env.NEXT_PUBLIC_SITE_URL || "",
    siteType: "UNKNOWN",
    gtmId: "",
    gaId: "",
    googleSiteVerificationCode: "",
    oneSignalAppId: fallbackOneSignalAppId,
  };
}
